import { StoreModel } from '@/models/store';
import { FEATURES } from '@/config/featureConfig';

export interface PurchaseListPermissionService {
  hasPermission(featureCode: string): boolean;
}

export interface PurchaseListAccessInputs {
  store: StoreModel | null | undefined;
  permissionService?: PurchaseListPermissionService | null;
  initializing?: boolean;
}

/**
 * Whether the merchant may use the Purchase List (header icon, selection
 * toolbar, "Add selected to Purchase List").
 *
 * Resolves the `purchase_orders` rule the same way Permission.vue does:
 * open while permissions are still loading, then $permissionService, then a
 * direct store rule check. Kept as a pure function so the gate is testable
 * without mounting a component — the rule itself may be granted by the
 * merchant's package or by a FeatureUnlock override, so never infer it from
 * the package name.
 */
export function hasPurchaseListAccess(inputs: PurchaseListAccessInputs): boolean {
  if (inputs.initializing === true) {
    return true;
  }
  if (inputs.permissionService) {
    return inputs.permissionService.hasPermission(FEATURES.PURCHASE_ORDERS);
  }
  const store = inputs.store;
  if (!store || typeof store.isValidateRule !== 'function') {
    return false;
  }
  return store.isValidateRule(FEATURES.PURCHASE_ORDERS, 'unlocked') || false;
}
